import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { MediaFeaturesService } from 'rev-shared/media/MediaFeatures.Service';
import { GoLiveFormComponent } from './GoLiveForm.Component';

import styles from './GoLive.module.less';
import { UserContextService } from 'rev-shared/security/UserContext.Service';

@Component({
	selector: 'go-live',
	templateUrl: './GoLive.Component.html',
	standalone: false
})
export class GoLiveComponent implements OnInit {
	@Input() public alwaysThemeAccent: boolean;
	@Input() public bgNone: boolean;
	@Input() public dropdownCssClass: string;
	@Input() public iconCssClass: string;
	@Input() public showRemove: string;
	@Input() public headerType: string;

	@ViewChild(GoLiveFormComponent)
	public form: GoLiveFormComponent;

	public readonly styles = styles;
	public isEnabled: boolean;

	constructor(
		private readonly mediaFeaturesService: MediaFeaturesService,
		private readonly userContext: UserContextService,
		private readonly el: ElementRef,
		private readonly renderer: Renderer2,
	) {}

	public ngOnInit(): void {
		this.mediaFeaturesService.getFeatures().then(features => {
			this.isEnabled = !features.onPrem &&
				!features.webcastSources.webrtcSinglePresenterDisabled &&
				!this.userContext.getAccount().isUniversalEcdn;

			if (this.isEnabled) {
				this.renderer.removeStyle(this.el.nativeElement, 'display');
			} else {
				this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
			}
		});
	}

	public resetForm(): void {
		this.form.initialize();
	}
}
